<template>
  <div>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <validation-observer ref="userformvalid">
      <div class="container-fluid mt--6">
      <card>
          <div class="row mb-2">
            <div class="col-lg-3 col-sm-12">
              <base-button outline type="primary" block @click="onBack()">
                <span class="btn-inner--icon">
                  <i class="ni sign-left"></i>
                </span>
                Back to main page</base-button
              >
            </div>
          </div>
      

        <div class="row justify-content-center">
          <div class="col-lg-3 order-lg-2">
            <div class="">
              <a href="#">
                <img class="rounded-circle profile-picture-md" :src="picture" />
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
          <div class="d-flex justify-content-between"></div>
        </div> -->
        <div>
          <h6 class="heading-small text-muted mb-4">Change picture</h6>

          <el-upload
            :action="uploadurl"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="afterUpload"
          >
            <base-button size="small" type="default"
              >Click to upload</base-button
            >
          </el-upload>
        </div>
        <br />
        <br />
        <h6 class="heading-small text-muted mb-4">User information</h6>

        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                rules="required"
                label="Full name"
                placeholder="Full name"
                v-model="currentUser.fullname"
                :disabled="true"
                name="Full name"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                type="email"
                label="Email"
                placeholder="user@email.com"
                v-model="currentUser.email"
                rules="required"
                name="email"
                :disabled="true"
              ></base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="number"
                label="Phone"
                placeholder="Phone"
                v-model="currentUser.phone"
                name="phone"
                rules="required"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                label="Date of birth"
                rules="required"
                name="Date of birth"
              >
                <flat-picker
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="currentUser.dob"
                ></flat-picker>
              </base-input>
            </div>
          </div>
        </div>
        <hr class="my-4" />

        <!-- Address -->
        <h6 class="heading-small text-muted mb-4">Contact information</h6>

        <div class="pl-lg-4">
          <div class="row">
            <div class="col-md-12">
              <base-input
                type="text"
                label="Address"
                placeholder="Home Address"
                v-model="currentUser.address"
              ></base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                label="City"
                placeholder="City"
                v-model="currentUser.city"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Country"
                placeholder="Country"
                v-model="currentUser.country"
              ></base-input>
            </div>
          </div>
        </div>

        <hr class="my-4" />
        <!-- Description -->

        <h6 class="heading-small text-muted mb-4">Additional</h6>
        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Company"
                placeholder="Company"
                v-model="currentUser.company"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                type="text"
                label="Position"
                placeholder="Position"
                v-model="currentUser.position"
              ></base-input>
            </div>
          </div>
        </div>
        <div class="pl-lg-4">
          <div class="form-group">
            <label class="form-control-label">About Me</label>
            <textarea
              rows="4"
              class="form-control"
              placeholder="A few words about you ..."
              v-model="currentUser.aboutme"
            ></textarea>
          </div>
        </div>
        <div class="pl-lg-0">
          <base-button block type="primary" @click.native="onSave"
            >Save changes</base-button
          >
        </div>
      </card>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { uploadUrl, fileUrl, nophoto } from "../../../services/helper";
import { GetUser, Update } from "../../../services/user";
import { Upload, Button, Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { Modal, BaseAlert } from "@/components";
import store from "../../../store";
import { color } from "d3";
import { SendMail } from "../../../services/mail";
import { resetpwd, newuser } from "../../../services/mtmpl";
import { GeneratePwd, Encrypt, GenerateHex } from "../../../services/crypto";
import { UserType, FileType } from "../../../services/types";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Modal,
    BaseAlert,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Upload.name]: Upload,
    [Button.name]: Button,
    Loading,
  },
  computed: {
    uploadurl() {
      return uploadUrl;
    },
    fileurl() {
      return fileUrl;
    },
    picture() {
      return !this.currentUser.picture
        ? nophoto
        : this.fileurl + this.currentUser.picture;
    },
  },
  data() {
    return {
      isLoading: false,
      currentUserId: this.$store.state.user.id,
      currentUser: {},
      model: {
        to: "",
        body: "",
        subject: "",
        alias: "HU Teaches",
      },
      sent: false,
    };
  },
  methods: {
    onBack() {
      this.$router.push({ name: "StudentMain" }).catch((e) => {});
    },
    onSave() {
      this.$refs.userformvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          Update(this.currentUser).then((response) => {
            this.isLoading = false;
            if (response.data.result) {
              this.notifyVue("success");
              if (this.$store.state.user.id === this.currentUser.id) {
                this.$store.dispatch("updateProfileData", this.currentUser);
              }
            } else {
              this.notifyVue("danger", response.data);
            }
          });
        }
      });
    },
    beforeUpload(file) {
      let fname = file.name;
      let key = GenerateHex();
      let newname = key + "_" + fname;
      Object.defineProperty(file, "name", {
        writable: true,
        value: newname,
      });
    },

    afterUpload(response, file, fileList) {
      if (!response.result) {
        this.notifyVue("danger", "Action failed!");
        return;
      }

      var f = new FileType();
      f.filename = file.raw.name;
      f.sourcetype = 9;
      f.sourceId = this.currentUserId;

      this.isLoading = true;
      this.$store.dispatch("updateProfilePicture", f).then((response) => {
        this.isLoading = false;
        if (response) {
          this.notifyVue("success", "Changes have been saved!");
          this.currentUser.picture =
            new Date().getFullYear().toString() + "/" + f.filename;
        } else this.notifyVue("danger", "Action failed!");
      });
    },
  },
  created() {
    this.currentUser = Object.assign({}, this.$store.state.user);
  },
};
</script>
